import { 
    trakrefBlue,
    Grey2,
    Grey3,
} from '../../color_utils';
import { 
    trakrefFontFamilySemiBold,
    trakrefFontSFNSRegular,
    trakrefFontFamily, 
} from "../../utils";

export const SaveButtonStyle = {
    backgroundColor: trakrefBlue,
    fontFamily: trakrefFontFamilySemiBold,
    fontSize: '12px',
    ":hover": {backgroundColor: trakrefBlue},
    marginRight: '-1%',
};

export const dialogBodyStyle = {
    font: trakrefFontSFNSRegular,
    fontSize: '13px',
    fontFamily: Grey2, 
    marginBottom: '13px',
}; 
export const dialogHeaderStyle = {
    font: trakrefFontFamilySemiBold,
    color: trakrefBlue,
    fontSize: '12px'
}; 

export const tableCellHeaderStyles = {
    fontFamily: trakrefFontFamily,
    color: Grey3,
    fontSize: "0.625rem",
    letterSpacing: '2px',
    borderBottom: 'none',
};

export const tableCellBodyStyles = {
    fontFamily: trakrefFontFamily,
    color: Grey2,
    fontSize: "0.813rem",
    borderBottom: 'none',
}; 